import React from 'react'
import CatalogSlider from '../../../components/CatalogSlider';

const Vertical = () => {
    const rollerImages = [
        {
          imgSrc: require('images/vertical/vertical-blinds.png'),
          headerText: 'Vertical Blinds',
          pdfUrl: require('catalogs/Vertical/vertical-blinds.pdf') 
        },
    ];
    

    return <>
        <CatalogSlider images={rollerImages} headerText="Vertical Blinds" shadesId='vertical' />;
    </>
}

export default Vertical